module.exports = __webpack_public_path__ + "tz.svg?ed1c43d0c76533c8e19f0e8afd0f604a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/tz.svg
// module id = 1411
// module chunks = 0